/**
 * common 模块提供通用的接口
 * @module common
 */

/**
 * 空函数
 * @method noop
 */
export const noop = () => {};

/**
 * 延迟函数
 * @method sleep
 * @param {Number} time 延迟时间（毫秒）
 * @return {Promise}
 */
export const sleep = time => new Promise(resolve => setTimeout(resolve, time));

/**
 * 获取运行时 id
 * tips：每次调用都返回一个运行时内唯一的 id，用于各种需要在运行时内临时生成互斥 id 的场景
 * @method runtimeId
 * @return {Number} 运行时 id
 */
let currentRuntimeId = 10000; // tips：默认从 10000 开始
export const runtimeId = () => currentRuntimeId++;
